angular.module('PatientApp').controller('VerificationCtrl', function($rootScope, $scope, PatientUsersService, $filter, $timeout, ErrorsService, Compass, $state, BillsService, EstimatesService) {
    var _deferWantingLogin = null,
        _resolveWithUser = function(user){
            if(_deferWantingLogin){
                _deferWantingLogin.resolve(user);
            }
        },
        _reset = function() {
            $scope.submitButtonText = $filter('translate')('verification.submitButtonText');
            $scope.promptVisible = false;
            $scope.failed = false;
            $scope.submitting = false;
            $scope.fields = {};
            $scope.fields.emailVerificationCode = '';
        },
        _resetNotifications = function() {
            $scope.verifyNotifications = {};
        };
   
    _reset();
    
    $rootScope.$on('verification:prompt', function(event, promptProperties) {
        $scope.email = promptProperties.email;
        $scope.promptVisible = true;
        $scope.explanation = $filter('translate')('verification.explanation', { email: $scope.email });
        if (promptProperties.defer != undefined) {
            _deferWantingLogin = promptProperties.defer;
        }
    });

    $scope.forms = {};

    $scope.submitEmailCode = function() {
        $scope.forms.verifyEmailCodeForm.$submitted = true;

        if ($scope.forms.verifyEmailCodeForm.$invalid || $scope.submitting || !$scope.fields.emailVerificationCode) {
            return;
        }

        $scope.submitting = true;
        $scope.submitButtonText = $filter('translate')('verification.submittingButtonText');

        _resetNotifications();

        Compass.capture.event('verify', 'email', 'started');

        PatientUsersService.confirmEmailVerifyCode($scope.fields.emailVerificationCode)
            .then(function(user) {
                Compass.capture.success('verify', 'email', '');

                _reset();
                
                //bill has been set as currentBill within billsService.  tell user about the successful link and
                //them point them toward the verify/payment flow.
                $scope.$emit('simpleModal:showPrompt', {
                    header: $filter('translate')('verification.successHeader'),
                    subcontent: $filter('translate')('verification.successSubheader'),
                    intent: 'success',
                    actions: [{
                        label: $filter('translate')('actions.continue'),
                        includeClasses: 'continue-button',
                        clickHandler: function(){
                            var estimate = EstimatesService.getCurrentEstimate();
                            
                            if (estimate) {
                                $state.go('app.dashboard.provider.details.estimate-details', {id: estimate.providerDetails.id, estimateId: estimate.id});
                            } else {
                                $state.go('app.verify');
                            }
                            _resolveWithUser(user);
                        }
                    }]
                });
            })
            .catch(function(resp) {
                Compass.capture.failure('verify', 'email', '');

                switch(ErrorsService.resolve(resp)){
                    case ErrorsService.errors.RATE_LIMIT_EXCEEDED:
                        $scope.verifyNotifications.bruteForce = true;
                        break;
                    default:
                        $scope.verifyNotifications.genericError = true;
                        break;
                }
            })
            .finally(function() {
                $scope.submitButtonText = $filter('translate')('verification.submitButtonText');
                $scope.submitting = false;
            });
    };

    $scope.resendVerification = function() {
        if($scope.resending) {
            return;
        }

        $scope.resending = true;

        PatientUsersService.resendVerification()
        .then(function() {
            $scope.emailSent = true;
            $timeout(function(){
                $scope.emailSent = false;
            }, 3000);
        })
        .catch(function() {
            $scope.failure = true;
            $timeout(function(){
                $scope.failure = false;
            }, 3000);
        })
        .finally(function(){
            $scope.resending = false;
        });
    };
});